"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;
var _react = _interopRequireWildcard(require("react"));
var _meta = require("./__generated__/__meta");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function IconFallback() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    style: {
      // this creates the same empty space as any loaded icon so the UI is not glitching
      width: '1em',
      height: '1em',
      display: 'inline-block'
    }
  });
}
function Icon(props) {
  const {
    name,
    ...restOfProps
  } = props;
  const IconComponent = _meta.ComponentsMap[name];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    style: {
      // aligns icon in the middle of the text
      verticalAlign: 'middle',
      display: 'inline-block'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconFallback, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
        ...restOfProps
      })
    })
  });
}